import { watchGetWordPair } from './getWordPair';
import { watchBearerToken } from './bearerToken';
import { watchOnRemember, watchOnForget } from './remember';
import { fork, all } from 'redux-saga/effects';

export default function* rootSaga() {
  yield all([
    fork(watchGetWordPair),
    fork(watchBearerToken),
    fork(watchOnRemember),
    fork(watchOnForget),
  ]);
}
